'use client';

/**
 * RfqHealthCard — RFQ tender health on the Insights rail.
 *
 * The RFQ drill-down analog of ObeyaHealthCard: a thin variant of the
 * shared <SynthesisCard /> bound to the `rfq_health` BFF strategy.
 * Resolves the selected RFQ from the viewport (`entityType === 'rfq'`);
 * `rfq_health` fans it out to the whole tender (x_rfq_group_id)
 * server-side.
 *
 * @see klyde_edge/ui_config/handlers/synthesis.py — rfq_health
 *
 * @component_role: Card
 * @component_type: Insights Card
 * @domain: Copilot / Insights (RFQ)
 * @layer: presentation
 */

import { Activity } from 'lucide-react';
import { SynthesisCard } from '@/components/canvas/cards/obeya/synthesis-card';
import { useViewportSelection } from '@/lib/stores/viewport-selection';

export function RfqHealthCard() {
  const { entityType, entityId } = useViewportSelection();
  const rfqSid = entityType === 'rfq' ? entityId : null;
  return (
    <SynthesisCard
      title="RFQ Health"
      strategy="rfq_health"
      pinStrategyName="rfq_health"
      entitySid={rfqSid}
      entityParam="rfq_sid"
      emptyLabel="Select an RFQ"
      Icon={Activity}
      iconColor="text-blue-400"
    />
  );
}
